<template>
  <div id="app">
    <div class="outer">
      <p>
        <label>属性名：</label>
        <input type="text" v-model="attr">
      </p>
      <p>
        <label>属性值：</label>
        <input type="text" v-model="val">
      </p>
      <p>
        <label></label>
        <button @click="handleActive">确定</button>
        <button @click="handleReset">重置</button>
      </p>
    </div>
    <div :style="[baseStyles, overridingStyles]">在上方输入框输入"属性名"及"属性值"，点击确定按钮查看效果。</div>
  </div>
</template>
<script>
export default {
  data:function(){
    return{
      attr:'background',
      val:'blue',
      isActive:false,
      baseStyles:{
        color:'#fff',
        width:'180px',
        height:'180px',
        background:'#000',
        margin:'0 auto',
        padding:'10px',        
      }
    }
  },  
  computed:{
    overridingStyles(){
      var newAttr={};
      if(this.isActive){
        newAttr[this.attr]=this.val;
      }
      return newAttr;
    }
  },
  methods:{
    handleActive(){
      this.isActive=true;
    },
    handleReset(){
      this.isActive=false
    }
  }
}
</script>

<style>
body,p{
  margin: 0;
  padding: 0;
}
body{
  color: #333;
  font: 12px/1.5 tahoma;
  padding-top: 10px;
}
.outer{
  width: 300px;
  margin: 0 auto;
}
p{
  margin-bottom: 10px;
}
button{
  margin-right: 5px;
}
label{
  width: 5em;
  display: inline-block;
  text-align: right;
}
input{
  padding: 3px;
  font-family: inherit;
  border: 1px solid #ccc;
  
}

</style>
